import { render, staticRenderFns } from "./cardItem.vue?vue&type=template&id=745c49bc&scoped=true"
import script from "./cardItem.vue?vue&type=script&lang=js"
export * from "./cardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c49bc",
  null
  
)

export default component.exports